import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlanInputs } from 'src/app/models/plan-inputs';
import {
  formatterDollar,
  formatterPercent,
  parserDollar,
  parserPercent,
} from 'src/app/utils/app-common';

@Component({
  selector: 'app-step-income-streams',
  templateUrl: './step-income-streams.component.html',
  styleUrls: ['./step-income-streams.component.scss']
})
export class StepIncomeStreamsComponent implements OnInit {

  @Input() inputs!: PlanInputs;
  @Output() validityChange = new EventEmitter<boolean>();

  formatterDollar = formatterDollar;
  parserDollar = parserDollar;
  formatterPercent = formatterPercent;
  parserPercent = parserPercent;

  constructor() {}

  ngOnInit(): void {
    this.validityChange.emit(true);
  }

  handleDataChange() {}
}
